<template>
  <kst-table paginated view-mode
    :data="items"
    :selected.sync="userData.selected"
  >
    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-image"
      field="DispatchImageSrc"
      :label="PurItemCatalog.DispatchImageSrc.Label"
    >
      <kst-image read-only thumbnail :src="row[column.field]"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      field="DispatchID"
      :label="PurItemCatalog.DispatchID.ColumnLabel"
    >
      <kst-value :field="column.field" :data="row" :catalog="PurItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-sku"
      field="SKU"
      :label="PurItemCatalog.SKU.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="PurItemCatalog"/>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-qty"
      field="QtyAvailable"
      :label="PurItemCatalog.QtyAvailable.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="PurItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-packaging"
      field="Packaging"
      :label="PurItemCatalog.Packaging.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="PurItemCatalog"/>
    </b-table-column>

    <template v-if="access.Fld_Amount" >
      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-price"
        field="BuyPrice"
        :label="PurItemCatalog.BuyPrice.Label"
      >
        <kst-value :field="column.field" :data="row" :catalog="PurItemCatalog"/>
      </b-table-column>
    </template>
  </kst-table>
</template>

<script>
import PurItemCatalog from "../PurItemCatalog.js";

export default {
  props: {
    access: Object,
    items: Array,
    userData: Object
  },
  data: () => ({
    PurItemCatalog: PurItemCatalog
  })
}
</script>